import ViewListIcon from '@material-ui/icons/ViewList';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Grid from '../../../../Common/Grid/index';
import getNoDataCellComponent from '../../../../Common/NoDataCellComponent/index';
import Icon from '../../../../Common/Icon/index';

import styles from './styles';
import Cell from '../../../../Common/Grid/Cell';
import Quantity from './Quantity';
import ItemTypeSelect from '../../../../Common/ItemTypeSelect';

const COLUMNS = [
  { name: 'icon', title: ' ' },
  { name: 'name', title: 'Name' },
  { name: 'quantity', title: 'Quantity' },
];

const COLUMN_EXTENSIONS = [
  { columnName: 'icon', width: 80 },
  { columnName: 'quantity', width: 150 },
];

const getCellComponent = (handleChangeQty) => ({ row, column, value }) => {
  switch (column.name) {
    case 'icon':
      return value ? (<Icon name={value} size={50}/>) : null;
    case 'quantity':
      return (<Quantity value={value} onChange={(value) => handleChangeQty(row.id, value)}/>);
    default :
      return value;
  }
};

const handleChange = (onValueChange, getGrid) => (value) => {
  onValueChange(value);
  setTimeout(() => getGrid().commitAdded(), 250);
};

const getInlineCellComponent = (itemTypes, getGrid) => ({ row, column, value, onValueChange, ...other }) => {
  switch (column.name) {
    case 'icon':
      return (<Cell colSpan={3}>
        <ItemTypeSelect
          itemTypes={itemTypes}
          value={row.id || '0007'}
          onChange={handleChange(onValueChange, getGrid)}
          fullWidth/>

      </Cell>);
    default:
      return null;
  }

};

class ItemTypesGrid extends Component {
  getGrid = () => {
    return this.grid;
  };

  handleAdd = (row) => {
    console.log('handleAdd', row.icon);
    const result = _.concat(this.props.itemTypes, [_.assign(row.icon, { quantity: 1 })]);
    console.log('onAdd', row, result);
    this.props.onChange(result);
  };

  handleRemove = (row) => {
    return Promise.resolve(this.props.onChange(this.props.itemTypes.filter((it) => it.id !== row.id)));
  };

  handleChangeQty = (itemTypeId, quantity) => {
    const { itemTypes } = this.props;
    this.props.onChange(itemTypes.map((itemType) => {
      if (itemType.id === itemTypeId) {
        itemType.quantity = quantity;
      }
      return itemType;
    }));
  };

  render() {
    const { itemTypes, availableItemTypes } = this.props;

    return (<Grid
      ref={(grid) => this.grid = grid}
      columns={COLUMNS}
      columnExtensions={COLUMN_EXTENSIONS}
      cellComponent={getCellComponent(this.handleChangeQty)}
      onAdd={this.handleAdd}
      onRemove={this.handleRemove}
      data={{ data: itemTypes }}
      fetch={_.noop}
      noDataCellComponent={getNoDataCellComponent(<ViewListIcon style={styles.noData}/>, 'item types')}
      inlineCellComponent={getInlineCellComponent(availableItemTypes, this.getGrid)}
    />);
  }

}

ItemTypesGrid.propTypes = {
  availableItemTypes: PropTypes.array.isRequired,
  itemTypes: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,

  showDialog: PropTypes.func.isRequired,
};

// function mapStateToProps(state) {
//   return {
//     itemTypes: state.get('itemtypes').get('itemTypes').toJS(),
//   };
// }
//
// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({
//     showDialog,
//     hideDialog,
//   }, dispatch);
// }

export default ItemTypesGrid;



// WEBPACK FOOTER //
// ./src/components/Admin/TaskProfiles/TaskProfileDialog/ItemTypesGrid/index.js